module.exports = function getResource(label, vars = []) {
    const resources = {
        default: 'Default',
        sort: 'Sort',
        sortBy: 'Sort by'
    };

    return resources[label];
};
